const studentUser6 = {
  id: '43245300-8a9e-11e8-bb2c-6b4501ec10b4',
  email: '',
  username: 'twostudent',
  firstName: 'Two',
  lastName: 'Student',
  fullName: 'Two Student',
  lastModified: 1531927244245,
  created: 1531927244245,
  role: 'Student',
  schoolDistrict: 'c85d02d0-2ff2-11e8-bb3c-cb20d31ae9b7',
  school: '2f6f80a0-324c-11e8-8fc9-99ad286ff1e3',
  classes: {
    '65cf4b30-8a9e-11e8-bb2c-6b4501ec10b4': true,
  },
  state: 'LA',
  validated: true,
}

export default studentUser6


// WEBPACK FOOTER //
// ./src/helpers/users/testing/studentUser6.js